// «Доступно обновление — обновить». Новая версия service worker ждёт, пока человек сам нажмёт
// «Обновить»: посреди тренировки страница без спроса не перезагрузится.

import { useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

import { useToast } from '@/components/ui'

const CHECK_EVERY_MS = 60 * 60 * 1000

export function UpdatePrompt() {
  const toast = useToast()
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return
      setInterval(() => {
        if (navigator.onLine) void registration.update()
      }, CHECK_EVERY_MS)
    },
  })

  useEffect(() => {
    if (!needRefresh) return
    toast.show({
      id: 'sw-update',
      message: 'Доступно обновление',
      tone: 'accent',
      duration: null,
      action: { label: 'Обновить', onClick: () => void updateServiceWorker(true) },
    })
  }, [needRefresh, toast, updateServiceWorker])

  return null
}
